import * as model from "@/model/adm/IntegrationMessageConfig";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter() {
    return model.filter;
}

export default newEntityStoreHelper(() => new model.IntegrationMessageConfig(), newFilter)
    .withStates({
        //TODO load at the application start
        idReport: -2,
        crudState: 'list',
        messageType: []
    })
    .withActions({
        loadMessageType(context){
            context.dispatch("api/get", {
                url: (context.state.baseModuleUrl +"/integrationMessageDefinition/findToComboBox")
            }, 
            {root: true})
            .then(function(data){
              context.commit("setMessageType", data);
            })
        }
    })
    .withMutations({
        setMessageType(state, messageType) {
            state.messageType = messageType;
        }
    })
    .buildStore()
